import { render, staticRenderFns } from "./formater-user.vue?vue&type=template&id=7b35402e&scoped=true"
import script from "./formater-user.vue?vue&type=script&lang=js"
export * from "./formater-user.vue?vue&type=script&lang=js"
import style0 from "./formater-user.vue?vue&type=style&index=0&id=7b35402e&prod&scoped=true&lang=css"
import style1 from "./formater-user.vue?vue&type=style&index=1&id=7b35402e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b35402e",
  null
  
)

/* custom blocks */
import block0 from "./formater-user.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports